import assert from "assert";

export class ISourceOfFundsDataStore {

  retrieveSof() {
    assert(false, 'SourceOfFundsDataStore.retrieveSof function not implimented')
  }
  storeSof(sof) {
    assert(false, 'SourceOfFundsDataStore.storeSof function not implimented')
  }
  createSofUser(user) {
    assert(false, 'SourceOfFundsDataStore.createSofUser function not implimented')
  }
  storeSofUser(sofUserId, user) {
    assert(false, 'SourceOfFundsDataStore.storeSofUser function not implimented')
  }
  retrieveSofUser(sofUserId) {
    assert(false, 'SourceOfFundsDataStore.retrieveSofUser function not implimented')
  }
  listSofUsers(sofId) {
    assert(false, 'SourceOfFundsDataStore.listSofUsers function not implimented')
  }

  addSofUserToAdmin(sofUserId) {
    assert(false, 'SourceOfFundsDataStore.addSofUserToAdmin function not implimented')
  }
  removeSofUserFromAdmin(sofUserId) {
    assert(false, 'SourceOfFundsDataStore.removeSofUserFromAdmin function not implimented')
  }
  resendPasswordToSofUser(sofUserId) {
    assert(false, 'SourceOfFundsDataStore.resendPasswordToSofUser function not implimented')
  }
  resetPasswordToSofUser(sofUserId) {
    assert(false, 'SourceOfFundsDataStore.resetPasswordToSofUser function not implimented')
  }
}

export default ISourceOfFundsDataStore